// extracted by mini-css-extract-plugin
export var container = "_ai-0";
export var containerTopRight = "_ai-1";